var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 11.677,
    viewBox: "0 0 15 11.677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-open",
    transform: "translate(-0.001 -56.735)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 2.499,
    cy: 2.499,
    r: 2.499,
    transform: "translate(5.001 60.074)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67634",
    "data-name": "Path 67634",
    d: "M14.542,60.961A8.274,8.274,0,0,0,7.5,56.735,8.274,8.274,0,0,0,.459,60.961a3.066,3.066,0,0,0,0,3.225A8.274,8.274,0,0,0,7.5,68.412a8.274,8.274,0,0,0,7.042-4.226A3.066,3.066,0,0,0,14.542,60.961ZM7.5,66.322a3.749,3.749,0,1,1,3.749-3.749A3.749,3.749,0,0,1,7.5,66.322Z",
    fill: "#202020"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.cde083204ddc985fab2ede2ebe831d3b.svg";
export { ForwardRef as ReactComponent };